{
  "it": {
    "modelPicker": {
      "hangarTitle": "Aggiungi navi al tuo hangar",
      "compareTitle": "Seleziona navi da confrontare",
      "wishlistTitle": "Aggiungi navi alla tua lista dei desideri",
      "labels": {
        "search": "Cerca per nome o produttore",
        "results": "%{count} navi",
        "selected": "%{count} selezionate"
      },
      "actions": {
        "resetFilters": "Reimposta i filtri",
        "clearSelection": "Cancella la selezione",
        "increase": "Aggiungi un'altra %{name}",
        "decrease": "Rimuovi una %{name}"
      },
      "badges": {
        "inHangar": "Nell'hangar",
        "onWishlist": "Nella lista dei desideri",
        "comparing": "Nel confronto"
      }
    }
  }
}
